import { render, staticRenderFns } from "./TetrisPieceRenderer.vue?vue&type=template&id=d9c2200e&scoped=true"
import script from "./TetrisPieceRenderer.vue?vue&type=script&lang=js"
export * from "./TetrisPieceRenderer.vue?vue&type=script&lang=js"
import style0 from "./TetrisPieceRenderer.vue?vue&type=style&index=0&id=d9c2200e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c2200e",
  null
  
)

export default component.exports